import actionTypes from './actionTypes'

const adminOnboardingActions = {
	initialize(params, path) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INITIALIZE,
			params,
			path,
		}
	},

	changeStep(step) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_CHANGE_STEP,
			step: step || 1,
		}
	},

	navigateToStep(step) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NAVIGATE_TO_STEP,
			step,
		}
	},

	initializeInvite() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INITIALIZE_INVITE_VIEW,
		}
	},

	cancelInviteConfirm() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INVITE_CANCELED,
		}
	},

	inviteConfirmed() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INVITE_CONFIRMED,
		}
	},

	inviteConfirmation() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INVITE_CONFIRMATION,
		}
	},

	addUser(values, resolve, reject) {
		return {
			...values,
			resolve,
			reject,
			type: actionTypes.ADMIN_ONBOARDING_ADD_USER,
		}
	},

	inviteUsers() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INVITE_USERS,
		}
	},

	joinColleagues() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_JOIN_COLLEAGUES,
		}
	},

	selectUser(index) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SELECT_USER,
			index,
		}
	},

	cancelSchoolConfirm() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SCHOOL_CANCELED,
		}
	},

	validateSchoolYes(institutionId) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SCHOOL_CONFIRM_YES,
			institutionId,
		}
	},

	validateSchoolNo(institutionId) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SCHOOL_CONFIRM_NO,
			institutionId,
		}
	},

	initializeConfirmSchool() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INITIALIZE_CONFIRM_SCHOOL_VIEW,
		}
	},

	initializeConfirmSchoolNo() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_INITIALIZE_CONFIRM_SCHOOL_NO,
		}
	},

	referContactInitialize() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_REFER_CONTACT_INITIALIZE,
		}
	},

	congratsToNearpodLibrary(redirectUrl) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_CONGRATS_TO_NEARPOD_LIBRARY,
			redirectUrl,
		}
	},

	redirectToMyLibrary(redirectUrl) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SCHOOL_CONFIRM_REDIRECT_TO_MY_LIBRARY,
			redirectUrl,
		}
	},

	acceptWelcomeInvite() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ACCEPT_WELCOME_INVITE,
		}
	},

	openReferAContactModal() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_REFER_CONTACT_MODAL_OPEN,
		}
	},

	closeReferAContactModal() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_REFER_CONTACT_MODAL_CLOSE,
		}
	},

	sendEmailToDM(values) {
		return {
			...values,
			type: actionTypes.ADMIN_ONBOARDING_REFER_A_CONTACT_SENT,
		}
	},

	skipToLastStep() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SKIP_TO_LAST_STEP,
		}
	},

	inviteColleague(values) {
		return {
			...values,
			type: actionTypes.ADMIN_ONBOARDING_INVITE_COLLEAGUE,
		}
	},

	animationCompleted() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ANIMATION_COMPLETED,
		}
	},

	skipStepFailed() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SKIP_FAILED,
		}
	},

	stepWhitelistError(redirectUrl) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_VALIDATE_STEP_WHITELIST_ERROR,
			redirectUrl,
		}
	},

	joinColleaguesSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_JOIN_COLLEAGUES_SUCCESS,
			step: 3,
		}
	},

	skipToLastStepRedirect() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_SKIP_TO_LAST_STEP_REDIRECT,
		}
	},

	validateStepFailed(redirectUrl) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_VALIDATE_STEP_FAILED,
			redirectUrl,
		}
	},

	noStoreDownloadsInitialize(offerTitle) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_INITIALIZE,
			offerTitle,
		}
	},

	noDMInformationInitialize(offerTitle) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_INITIALIZE,
			offerTitle,
		}
	},

	noStoreDownloadExploreLessons() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS,
		}
	},

	noStoreDownloadGoToMyLibrary() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_GO_TO_MY_LIBRARY,
		}
	},

	noStoreDownloadsExplorerLessonsMetricsSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS_METRICS_SUCCESS,
		}
	},

	noStoreDownloadsExplorerLessonsSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS_SUCCESS,
		}
	},

	addTeachersInitialize(offerTitle) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_INITIALIZE,
			offerTitle,
		}
	},

	addTeachersInitializeView() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_INITIALIZE_VIEW,
		}
	},

	addTeachersShareColleagues() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES,
		}
	},

	shareTeachersInitialize() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_INITIALIZE,
		}
	},

	shareTeachersAction() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_ACTION,
		}
	},

	shareTeachersConfirmationAction() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMATION,
		}
	},

	shareConfirmed() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMED,
		}
	},

	cancelShareConfirmed() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CANCELED,
		}
	},

	shareRedirect() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_REDIRECT,
		}
	},

	shareTeachersMetricsSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_METRICS_SUCCESS,
		}
	},

	shareTeachersSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES_SUCCESS,
		}
	},

	noDMInformationReferContact() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT,
		}
	},

	noDMInformationGoToMyLibrary() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_GO_TO_MY_LIBRARY,
		}
	},

	noDMInformationReferContactClose() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_CLOSE,
		}
	},

	noDMInformationReferContactCloseSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_CLOSE_SUCCESS,
		}
	},

	noDMInformationReferContactSend(values) {
		return {
			...values,
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND,
		}
	},

	noDMInformationReferContactSendSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND_SUCCESS,
		}
	},

	noDMInformationReferContactMetricsSuccess() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_METRICS_SUCCESS,
		}
	},

	premiumActivitiesNotificationInitialize(offerTitle) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_INITIALIZE,
			offerTitle,
		}
	},

	premiumActivitiesGoToMyLibrary() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_GO_TO_MY_LIBRARY,
		}
	},

	premiumActivitiesAddLesson() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON,
			step: 1,
		}
	},

	premiumActivitiesAddLessonCompleted() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON_COMPLETED,
			step: 2,
		}
	},

	premiumActivitiesShowMyLibrary() {
		return {
			type: actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_SHOW_MY_LIBRARY,
		}
	},

	getTrialDataCompleted(durationDays, isTrialFromSF = false) {
		return {
			type: actionTypes.ADMIN_ONBOARDING_GET_TRIAL_DATA_COMPLETED,
			durationDays,
			isTrialFromSF,
		}
	},
}

export default adminOnboardingActions
